import { render } from "./articleLeft.vue?vue&type=template&id=1b83dea6&scoped=true"
import script from "./articleLeft.vue?vue&type=script&lang=js"
export * from "./articleLeft.vue?vue&type=script&lang=js"

import "./articleLeft.vue?vue&type=style&index=0&id=1b83dea6&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b83dea6"]])

export default __exports__